import memoize from 'lru-memoize'
import { createValidator, required, email } from 'utility/validation'

const ResetPasswordFormValidation = createValidator({
  email: [required, email],
})
export default memoize(10)(ResetPasswordFormValidation)
